export const combineStrings = (...args: string[]) => args.join("");
